import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'csv-to-json',
  name: 'CSV to JSON',
  category: 'utilities',
  description: 'Convert CSV data to JSON format',
  icon: 'FileJson',
  color: 'blue',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
